import dayjs from 'dayjs';
import { type InitOptions } from 'i18next';

import {
  AVAILABLE_LANGUAGES,
  DEFAULT_LANGUAGE_KEY,
  DEFAULT_NAMESPACE,
} from '@/lib/i18n/constants';
import locales from '@/locales';

dayjs.locale(DEFAULT_LANGUAGE_KEY);

export const i18nConfig: InitOptions = {
  defaultNS: DEFAULT_NAMESPACE,
  ns: Object.keys(locales[DEFAULT_LANGUAGE_KEY]),
  resources: locales,
  fallbackLng: DEFAULT_LANGUAGE_KEY,

  keySeparator: '.',
  nsSeparator: ':',

  interpolation: {
    escapeValue: false, // react already safes from xss
  },
  supportedLngs: AVAILABLE_LANGUAGES.map((x) => x.key),

  detection: {
    order: ['path', 'localStorage'],
    lookupQuerystring: 'i18n-prefs',
    lookupCookie: 'i18n-prefs',
    lookupLocalStorage: 'i18n-prefs',
    lookupSessionStorage: 'i18n-prefs',
  },
};
